import { z } from "zod";
import { isValidPhoneNumber } from "react-phone-number-input";
import { sirenOrSiretSchema, vatSchema, validateVatWithSiren } from "../utils";

export const ModifyProProfileSchema = z
  .object({
    firstName: z.string().min(2, "Minimum 2 caractères").max(64).optional(),
    lastName: z.string().min(2, "Minimum 2 caractères").max(64).optional(),
    email: z.string().email("Veuillez entrer un email valide").optional(),
    phoneNumber: z
      .string()
      .nullable()
      .refine(
        (phone) => {
          if (!phone) return true;
          return isValidPhoneNumber(phone, "FR");
        },
        {
          message: "Téléphone invalide",
        }
      ),
    businessName: z.string().nullable(),
    siret: sirenOrSiretSchema.optional().nullable(),
    vat: vatSchema.optional().nullable(),
    password: z.string().nullable(),
    country: z.string().nullable(),
  })
  .superRefine((values, ctx) => {
    if (!values.siret && values.vat) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message:
          "Vous devez renseigner un numéro SIRET pour pouvoir renseigner un numéro de TVA",
        path: ["vat"],
      });
    }

    validateVatWithSiren(ctx, values.vat, values.siret);
  });

export const defaultModifyProProfileValues = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  siret: null,
  vat: null,
  businessName: null,
  country: null,
};

export type ModifyProProfileForm = z.infer<typeof ModifyProProfileSchema>;
